






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { Device, Info, User, ApiKey } from '@/types/core';
import { DateTime } from 'luxon';
import { curCoreClient, CoreClient } from '@/services/CoreClient';

import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';

@Component({
  components: {
    VueError,
    Success,
    ConfirmedAction
  },
})
export default class DeleteApiKey extends Vue {

  @Prop({ default: {},  type: Object}) apiKey!: ApiKey;

  error:string = '';
  success:string = '';

  private coreClient:CoreClient = curCoreClient;
  
  
  async deleteApiKey() {

    const reply = await this.coreClient.deleteApiKey({apiKey: this.apiKey.apiKey});
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to delete API key: ${reply.errorMsg}`;
    
    this.setSuccess(`ApiKey ${this.apiKey.apiKey} has been deleted`);
  }

  maskApiKey(apiKey:string):string {
    return apiKey.substring(0, 10) + "*****" + apiKey.substring(30);
  }


  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
